import { Injectable } from '@angular/core';

import { ApAnalyticsService, ClickAnalyticsData, PageviewAnalyticsData } from '@ap/analytics';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    public constructor(private readonly analyticsService: ApAnalyticsService) {}

    public pushSearchTermAnalytics(searchTerm: string): void {
        this.analyticsService.push(new ClickAnalyticsData('ap-search', 'search', undefined, undefined, undefined, searchTerm, ['search']));
    }

    public pushSearchResultAmountAnalytics(searchTerm: string, amountOfResults: number): void {
        const resultatenPresentation = amountOfResults > 0 ? '0 tot 10 resultaten' : '0 resultaten';
        let obj = new PageviewAnalyticsData(
            'ap-search',
            'search',
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            resultatenPresentation
        );
        this.analyticsService.push(obj);
    }
}
